<template>
<div class="chapter">
<div class="inner_page">
<h1>Gil Walsh</h1>
<div class="toc"><p><b>Table of Contents</b></p><dl>
<dt><span class="chapter"><a href="#/ch01">Foreword</a></span></dt>
<dt><span class="chapter"><span href="#/ch02" title="Link target outside of Sample">Lush Layering </span></span></dt>
<dt><span class="chapter"><span href="#/ch03" title="Link target outside of Sample">Jewel Tones </span></span></dt>
<dt><span class="chapter"><span href="#/ch04" title="Link target outside of Sample">Country Chic </span></span></dt>
<dt><span class="chapter"><span href="#/ch05" title="Link target outside of Sample">By the Sea </span></span></dt>
<dt><span class="chapter"><span href="#/ch06" title="Link target outside of Sample">In the Clouds </span></span></dt>
<dt><span class="chapter"><span href="#/ch07" title="Link target outside of Sample">Historical Treasures </span></span></dt>
<dt><span class="chapter"><span href="#/ch08" title="Link target outside of Sample">Blue on Blue </span></span></dt>
<dt><span class="chapter"><span href="#/ch09" title="Link target outside of Sample">Riot of Color </span></span></dt>
<dt><span class="chapter"><span href="#/ch10" title="Link target outside of Sample">Show Houses </span></span></dt>
</dl></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01toc.vue?36af30e2